/** InsCoder WANG.J 2026-07-15 B + Register comparison table custom element **/
if (!customElements.get("cust-comparison-table")) {
  customElements.define(
    "cust-comparison-table",
    class CustComparisonTable extends HTMLElement {
      connectedCallback() {
        this.productInfos = Array.from(
          this.querySelectorAll(".cust-comparison-table__product-info"),
        );
        this.handleWindowResize = () => {
          this.scheduleProductInfoHeightUpdate();
          if (this.body) this.updateToggleVisibility();
        };
        window.addEventListener("resize", this.handleWindowResize);
        this.productInfoResizeObserver = new ResizeObserver(() =>
          this.scheduleProductInfoHeightUpdate(),
        );
        this.productInfos.forEach((productInfo) => {
          Array.from(productInfo.children).forEach((child) =>
            this.productInfoResizeObserver.observe(child),
          );
        });
        document.fonts?.ready.then(() => this.scheduleProductInfoHeightUpdate());
        this.scheduleProductInfoHeightUpdate();

        if (this.dataset.collapseMobileEnabled !== "true") return;

        this.body = this.querySelector(".cust-comparison-table__body.is-collapsible");
        this.toggle = this.querySelector(".cust-comparison-table__toggle");
        if (!this.body || !this.toggle) return;

        this.toggle.addEventListener("click", () => this.toggleExpanded());
        this.resizeObserver = new ResizeObserver(() => this.updateToggleVisibility());
        this.resizeObserver.observe(this.body);
        this.updateToggleVisibility();
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.productInfoHeightFrame);
        this.productInfoResizeObserver?.disconnect();
        this.resizeObserver?.disconnect();
        if (this.handleWindowResize) {
          window.removeEventListener("resize", this.handleWindowResize);
        }
      }

      scheduleProductInfoHeightUpdate() {
        cancelAnimationFrame(this.productInfoHeightFrame);
        this.productInfoHeightFrame = requestAnimationFrame(() =>
          this.updateProductInfoHeight(),
        );
      }

      updateProductInfoHeight() {
        if (!this.productInfos?.length) return;

        this.productInfos.forEach((productInfo) =>
          productInfo.style.removeProperty(
            "--cust-comparison-product-info-height",
          ),
        );
        const maxHeight = Math.max(
          ...this.productInfos.map((productInfo) => productInfo.offsetHeight),
        );
        this.productInfos.forEach((productInfo) =>
          productInfo.style.setProperty(
            "--cust-comparison-product-info-height",
            `${maxHeight}px`,
          ),
        );
      }

      updateToggleVisibility() {
        const isExpanded = this.body.classList.contains("is-expanded");
        const collapsedHeight = parseFloat(
          getComputedStyle(this.body).maxHeight,
        );
        const hasOverflow =
          isExpanded || this.body.scrollHeight > collapsedHeight + 1;
        this.body.classList.toggle("has-overflow", hasOverflow);
        this.toggle.hidden = !hasOverflow;
        this.toggle.setAttribute("aria-expanded", String(isExpanded));
      }

      toggleExpanded() {
        const isExpanded = this.body.classList.toggle("is-expanded");
        if (isExpanded) {
          this.body.style.setProperty(
            "--cust-comparison-expanded-height",
            `${this.body.scrollHeight}px`,
          );
        } else {
          this.body.style.removeProperty("--cust-comparison-expanded-height");
        }
        this.updateToggleVisibility();
      }
    },
  );
}
/** InsCoder WANG.J 2026-07-15 E + Register comparison table custom element **/
